<script setup lang="ts">
import type { UploadImagePreprocessOptions } from '../runtime/imageEditor';
import CCropper from '../Cropper.vue';

const { $t } = useLocalization();

const props = withDefaults(defineProps<{
    previewFile?: File;
}>(), {
    previewFile: null
});

defineModel<UploadImagePreprocessOptions>({ required: true });

const emit = defineEmits<{
    (e: 'cropped', source: File, replacement: File): void;
}>();

const dialogId = `filemanager-upload-preprocess-modal-${useId()}`;

function showModal()
{
    useDialog(dialogId).open();
}

function onLocalSaved(file: File)
{
    emit('cropped', props.previewFile, file);
    useDialog(dialogId).close();
}

defineExpose({
    showModal
});
</script>

<template>
    <IdeoModal
        :id="dialogId"
        :title="$t('[[[Modyfikacja obrazu przed wysłaniem]]]')"
        layer="nested"
        viewport="workspace"
        class="[&_.file-image-editor]:!h-full [&_.file-image-editor]:!min-h-0 [&_.file-image-editor]:!rounded-none [&_.file-image-editor]:!border-0"
        body-padding="none"
        body-height="fill"
        body-overflow="hidden"
        hide-footer
    >
        <template #modal-header="{ cancel }">
            <div class="flex min-h-[44px] shrink-0 items-center gap-[10px] border-b border-border px-[12px] py-[7px] dark:border-border-dark">
                <h2 class="min-w-0 flex-1 truncate text-ui-body font-[600] text-fg dark:text-fg-dark">{{ $t('[[[Modyfikacja obrazu przed wysłaniem]]]') }}</h2>
                <IdeoAction variant="secondary" icon="x" :aria-label="$t('[[[Zamknij]]]')" :title="$t('[[[Zamknij]]]')" @click="cancel" />
            </div>
        </template>
        <CCropper
            v-if="previewFile"
            :key="`${previewFile.name}.${previewFile.size}.${previewFile.lastModified}`"
            :enabled="true"
            :source-file="previewFile"
            scope="public"
            @local-saved="onLocalSaved"
        />
    </IdeoModal>
</template>
